import React, { useEffect, useRef, useState } from "react";
// import NotificationIcon from "../../../assets/icons/NotificationIcon";
import { getMessage } from "../../../../lib/translator";
import API from "../../../../lib/api";
import NoNotification from "./NoNotification";
import { useOutsideClick } from "../../../../utils/commonHooks";
import NotificationsListUI from "./NotificationsListUI";
import NotificationIcon from "./NotificationIcon";
import "./style.css";

export default function InAppNotification() {
  const [showModal, setShowModal] = useState(false);
  const [notifications, setNotifications] = useState({
    read: [],
    unread: [],
  });
  const notifyRef = useRef();

  useOutsideClick(notifyRef, () => setShowModal(false)); //Custom hook to handle outside click

  const handleModalClick = (e) => {
    e.stopPropagation();
    setShowModal((prev) => !prev);
  };

  const fetchNotifications = () => {
    const api = new API({ url: "/communication-service/notification" });
    api
      .get({ appType: "adminApp" })
      .then((response) => {
        const { notifications = [] } = response?.data || {};
        const { read, unread } = (notifications || [])?.reduce(
          (acc, notification) => {
            if (notification.read) {
              acc.read.push(notification);
            } else {
              acc.unread.push(notification);
            }
            return acc;
          },
          { read: [], unread: [] }
        );
        setNotifications({ read, unread });
      })
      .catch((error) => {
        console.error(error);
      });

    return [];
  };
  useEffect(() => {
    fetchNotifications();
  }, []);

  const updateNotificationReadStatus = (id, all) => {
    const api = new API({ url: `/communication-service/notification/${id}` });
    const payload = all
      ? { readAll: true, appType: "adminApp" }
      : { read: true, appType: "adminApp" };
    api.put(payload).then(() => {
      fetchNotifications();
    });
  };

  const handleNotifyItemClick = (e, id, all) => {
    e.stopPropagation();
    updateNotificationReadStatus(id, all);
  };

  const { read, unread } = notifications;
  const unreadCount = unread?.length || 0;

  return (
    <div className="in-app-notify" ref={notifyRef}>
      <div className="notify-icon" onClick={handleModalClick}>
        <NotificationIcon width={30} height={30} />
        {unreadCount > 0 && !showModal && <div className="alert-icon"></div>}
      </div>
      {showModal && (
        <div className="notify-box">
          <div className="notify-header">
            <div className="notify-unread">
              <div>{getMessage("notifications.text")}</div>
              {unreadCount > 0 && (
                <div className="unread-count">{unreadCount} unread</div>
              )}
            </div>
            {unreadCount > 0 && (
              <div
                className="mark-all"
                onClick={(e) => handleNotifyItemClick(e, -1, true)}
              >
                {getMessage("mark.all.read.text")}
              </div>
            )}
          </div>
          <div className="notify-list-container">
            {unreadCount === 0 && read?.length === 0 ? (
              <div className="empty-notification">
                <NoNotification />
                {getMessage("you're.all.caught.up!.text")}
              </div>
            ) : (
              <>
                <NotificationsListUI
                  data={unread}
                  handleNotifyItemClick={handleNotifyItemClick}
                />
                <NotificationsListUI
                  data={read}
                  handleNotifyItemClick={handleNotifyItemClick}
                  read
                />
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
